export const REOWN_URL = 'https://reown.com';
//# sourceMappingURL=ConstantsUtil.js.map